import { render } from "./StudentTable.vue?vue&type=template&id=71dad580&scoped=true"
import script from "./StudentTable.vue?vue&type=script&lang=js"
export * from "./StudentTable.vue?vue&type=script&lang=js"

import "./StudentTable.vue?vue&type=style&index=0&id=71dad580&scoped=true&lang=css"

import exportComponent from "D:\\EME_MARKETING_AND_CONSULTING\\_Proyectos\\bookapps\\Apps Code\\web-admin-bookapps-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71dad580"]])

export default __exports__